/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Phase_ApplyInputs */

const en_nav_phase_apply = /** @type {(inputs: Nav_Phase_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply`)
};

const de_nav_phase_apply = /** @type {(inputs: Nav_Phase_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerben`)
};

const fr_nav_phase_apply = /** @type {(inputs: Nav_Phase_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postuler`)
};

const es_nav_phase_apply = /** @type {(inputs: Nav_Phase_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar`)
};

const it_nav_phase_apply = /** @type {(inputs: Nav_Phase_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Candidati`)
};

const nl_nav_phase_apply = /** @type {(inputs: Nav_Phase_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solliciteren`)
};

const pl_nav_phase_apply = /** @type {(inputs: Nav_Phase_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplikuj`)
};

const fi_nav_phase_apply = /** @type {(inputs: Nav_Phase_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hae`)
};

const da_nav_phase_apply = /** @type {(inputs: Nav_Phase_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansøg`)
};

const sv_nav_phase_apply = /** @type {(inputs: Nav_Phase_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansök`)
};

/**
* | output |
* | --- |
* | "Apply" |
*
* @param {Nav_Phase_ApplyInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const nav_phase_apply = /** @type {((inputs?: Nav_Phase_ApplyInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Phase_ApplyInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nav_phase_apply(inputs)
	if (locale === "fr") return fr_nav_phase_apply(inputs)
	if (locale === "es") return es_nav_phase_apply(inputs)
	if (locale === "it") return it_nav_phase_apply(inputs)
	if (locale === "nl") return nl_nav_phase_apply(inputs)
	if (locale === "pl") return pl_nav_phase_apply(inputs)
	if (locale === "fi") return fi_nav_phase_apply(inputs)
	if (locale === "da") return da_nav_phase_apply(inputs)
	if (locale === "sv") return sv_nav_phase_apply(inputs)
	return en_nav_phase_apply(inputs)
});